import classnames from 'classnames';
import React from 'react';
import { ActionItem as WixBaseUIActionItem } from '@wix/wix-base-ui';
import styles from './ActionItem.scss';

export const ActionItem: typeof WixBaseUIActionItem = ({ className, componentType = '', ...otherProps }) => (
  <div data-comp={componentType}>
    <WixBaseUIActionItem {...otherProps} className={classnames(styles.item, className)} />
  </div>
);
